import React, { useContext } from 'react'
import { Col, Row, Card, Table, Badge } from '@themesberg/react-bootstrap'
import { Context } from '../SepayTransactionList'
import Pagination from '../../../../components/Pagination';
import moment from 'moment-timezone';

const statusVariant = {
  SUCCESS: 'success',
  PENDING: 'warning',
  IGNORED: 'secondary',
  FAILED: 'danger',
}

const formatNumber = (num) => new Intl.NumberFormat('vn-VI').format(num || 0)

const TableRow = ({ rIndex, gateway, accountNumber, transferAmount, content, referenceCode, status, user, transactionChargeId, createdAt }) => {
  return (
    <tr>
      <td className='text-center'>{rIndex + 1}</td>
      <td className='text-center'>{moment(createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
      <td>{gateway}</td>
      <td>{accountNumber}</td>
      <td className='text-right fw-900 text-success'>{formatNumber(transferAmount)}</td>
      <td>{content}</td>
      <td>{referenceCode}</td>
      <td className='text-center'>
        <Badge bg={statusVariant[status] || 'light'}>{status}</Badge>
      </td>
      <td>{user ? user.phone : ''}</td>
      <td>{transactionChargeId || ''}</td>
    </tr>
  )
}

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <small>Tổng: <b>{state.data.total}</b> bản ghi</small>
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Ngày</th>
              <th scope="col">Gateway</th>
              <th scope="col">Số TK</th>
              <th scope="col">Số tiền</th>
              <th scope="col">Nội dung CK</th>
              <th scope="col">Mã tham chiếu</th>
              <th scope="col">Trạng thái</th>
              <th scope="col">User (SĐT)</th>
              <th scope="col">Mã giao dịch</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => (
              <TableRow
                rIndex={index + (state.filter.page * 100)}
                key={`sepay-tx-${pv.id}`}
                {...pv}
              />
            ))}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)
